/* ============================================================
   VBE — VEILED BEAD EXTENSIONS
   Main JavaScript
   Scroll reveal, header behavior, and interactive effects
   ============================================================ */

(function() {
  'use strict';

  /* --- Scroll Reveal Observer --- */
  function initScrollReveal() {
    const elements = document.querySelectorAll('.vbe-reveal, .vbe-stagger');
    if (!elements.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* --- Header Scroll Behavior --- */
  function initHeaderScroll() {
    const header = document.querySelector('.vbe-header');
    if (!header) return;

    let lastScrollY = 0;
    let ticking = false;

    function updateHeader() {
      const scrollY = window.scrollY;

      if (scrollY > 80) {
        header.classList.add('vbe-header--scrolled');
      } else {
        header.classList.remove('vbe-header--scrolled');
      }

      if (scrollY > lastScrollY && scrollY > 300) {
        header.classList.add('vbe-header--hidden');
      } else {
        header.classList.remove('vbe-header--hidden');
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Mobile Menu Toggle --- */
  function initMobileMenu() {
    const toggle = document.querySelector('.vbe-header__mobile-toggle');
    const nav = document.querySelector('.vbe-header__nav');
    const body = document.body;

    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      const isOpen = nav.classList.contains('is-open');
      nav.classList.toggle('is-open');
      toggle.classList.toggle('is-active');
      body.style.overflow = isOpen ? '' : 'hidden';
    });

    // Close on link click
    nav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        nav.classList.remove('is-open');
        toggle.classList.remove('is-active');
        body.style.overflow = '';
      });
    });
  }

  /* --- Smooth Scroll for Anchor Links --- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();
        const headerHeight = document.querySelector('.vbe-header')?.offsetHeight || 80;
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      });
    });
  }

  /* --- Lazy Image Loading --- */
  function initLazyImages() {
    const images = document.querySelectorAll('.vbe-image-load');
    if (!images.length) return;

    images.forEach(function(img) {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('loaded');
        });
      }
    });
  }

  /* --- Counter Animation --- */
  function initCounters() {
    const counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.getAttribute('data-count-to'));
          const duration = 2000;
          const start = 0;
          const startTime = performance.now();

          function animate(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.round(start + (target - start) * eased);
            el.textContent = current.toLocaleString();

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          }

          requestAnimationFrame(animate);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(counter) {
      observer.observe(counter);
    });
  }

  /* --- Announcement Bar Close --- */
  function initAnnouncementBar() {
    const closeBtn = document.querySelector('.vbe-announcement__close');
    const bar = document.querySelector('.vbe-announcement');
    if (!closeBtn || !bar) return;

    closeBtn.addEventListener('click', function() {
      bar.style.maxHeight = bar.offsetHeight + 'px';
      requestAnimationFrame(function() {
        bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
        bar.style.maxHeight = '0';
        bar.style.opacity = '0';
        bar.style.overflow = 'hidden';
      });
      sessionStorage.setItem('vbe-announcement-closed', 'true');
    });

    if (sessionStorage.getItem('vbe-announcement-closed') === 'true') {
      bar.style.display = 'none';
    }
  }

  /* --- Initialize All --- */
  function init() {
    initScrollReveal();
    initHeaderScroll();
    initMobileMenu();
    initSmoothScroll();
    initLazyImages();
    initCounters();
    initAnnouncementBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
